<template>
  <v-card class="pa-4" width="100%" flat>
    <v-toolbar dense tile flat color="grey lighten-3" class="ma-2">
      <v-toolbar-title>PRODUCTION</v-toolbar-title>
    </v-toolbar>
    <v-layout wrap>
      <v-flex xs12 sm4 pa-2>
        <v-card class="elevation-2" color="blue-grey darken-3">
          <v-card-title>
            <v-flex xs3>
              <div class="panel-label-text white--text text-center">{{ currentLabels.totalTarget }}</div>
            </v-flex>
          <v-flex xs9 class="text-right">
            <h3 class="panel-data-text white--text">{{ total.target.toLocaleString() }}              
            </h3>
          </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 pa-2>
        <v-card class="elevation-2" color="blue-grey darken-3">
          <v-card-title>
            <v-flex xs3>
              <div class="panel-label-text white--text text-center">{{ currentLabels.totalCount }}</div>
            </v-flex>
          <v-flex xs9 class="text-right">
            <h3 class="panel-data-text white--text"> {{ total.count.toLocaleString() }}
            </h3>
          </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 pa-2>
        <v-card class="elevation-2" color="blue-grey darken-3">
          <v-card-title>
            <v-flex xs3>
              <div class="panel-label-text white--text text-center">{{ currentLabels.totalProduction }}</div>
            </v-flex>
          <v-flex xs9 class="text-right">
            <h3 class="panel-data-text white--text">{{ total.rate.toFixed(1)}} %</h3>
          </v-flex>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex lg4 md12 sm12 xs12 pa-2>
        <v-toolbar color="blue-grey lighten-2" dark dense>
            <v-icon class="black--text">mdi-check-network</v-icon>
            <v-toolbar-title class="ml-1 black--text">GATE 1</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="d-lg-none d-block d-xl-block">
              <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate1.target.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate1.count.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text red--text title-text">{{ currentLabels.production }} {{ gateTotal.gate1.rate.toFixed(1)}} %</span>
            </div>
        </v-toolbar> 
        <v-card class="white--text subheading">
          <v-container class="equip-card">
            <v-row dense align="center" justify="center" class="d-lg-block d-xl-none d-none">
              <v-col cols="12">
                <v-card color="" flat tile height="42" class="text-center grey lighten-2" >
                  <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate1.target.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate1.count.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text red--text  title-text">{{ currentLabels.production }} {{ gateTotal.gate1.rate.toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense align="center" justify="center" v-for="(item, i) in rtData.gate1" :key="i" >
              <v-col cols="2" lg="2" class="max-100">
                <v-card :color="getStatusLevel(item.Non_Operation_Type)" flat tile height="42" class="text-center" >
                  <span class="gate-text equip-text">{{ item.Line }}</span>
                </v-card>
              </v-col>
              <v-col cols="8" lg="8" class="flex-space-production">
                <v-card flat tile class="equip-text">
                  <v-progress-linear v-if="timeset() == 'DAY'" color="green" :value="ProductionRate(item.Count_Day, item.Target_Day)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Day).toLocaleString() }} / {{ Number(item.Count_Day).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                  <v-progress-linear v-else color="green" :value="ProductionRate(item.Count_Night, item.Target_Night)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Night).toLocaleString() }} / {{ Number(item.Count_Night).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                </v-card>
              </v-col>
              <v-col cols="2" lg="2" class="max-100">
                <v-card v-if="timeset() == 'DAY'" flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Day, item.Target_Day).toFixed(1)}} %</span>
                </v-card>
                <v-card v-else flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Night, item.Target_Night).toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions class="blue-grey lighten-2 text-center card-tail">
            <span class="gate-text equip-text">{{ currentLabels.equipStatus  }}</span><span class="ml-8 gate-text equip-text">{{ gateTotal.gate1.statusNormal }} / {{ gateTotal.gate1.statusTotal }}</span>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg4 md12 sm12 xs12 pa-2>
        <v-toolbar color="blue-grey lighten-2" dark dense>
            <v-icon class="black--text">mdi-check-network</v-icon>
            <v-toolbar-title class="ml-1 black--text">GATE 2</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="d-lg-none d-block d-xl-block">
              <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate2.target.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate2.count.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text red--text  title-text">{{ currentLabels.production }} {{ gateTotal.gate2.rate.toFixed(1)}} %</span>
            </div>
        </v-toolbar> 
        <v-card class="white--text subheading">
          <v-container class="equip-card">
            <v-row dense align="center" justify="center" class="d-lg-block d-xl-none d-none">
              <v-col cols="12" >
                <v-card color="" flat tile height="42" class="text-center grey lighten-2" >
                  <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate2.target.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate2.count.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text red--text  title-text">{{ currentLabels.production }} {{ gateTotal.gate2.rate.toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense align="center" justify="center" v-for="(item, i) in rtData.gate2" :key="i" >
              <v-col cols="2" lg="2" class="max-100">
                <v-card color="green" flat tile height="42" class="text-center" >
                  <span class="gate-text equip-text">{{ item.Line }}</span>
                </v-card>
              </v-col>
              <v-col cols="8" lg="8" class="flex-space-production">
                <v-card flat tile class="equip-text">
                  <v-progress-linear v-if="timeset() == 'DAY'" :color="getStatusLevel(item.Non_Operation_Type)" :value="ProductionRate(item.Count_Day, item.Target_Day)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Day).toLocaleString() }} / {{ Number(item.Count_Day).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                  <v-progress-linear v-else :color="getStatusLevel(item.Non_Operation_Type)" :value="ProductionRate(item.Count_Night, item.Target_Night)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Night).toLocaleString() }} / {{ Number(item.Count_Night).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                </v-card>
              </v-col>
              <v-col cols="2" lg="2" class="max-100">
                <v-card v-if="timeset() == 'DAY'" flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Day, item.Target_Day).toFixed(1)}} %</span>
                </v-card>
                <v-card v-else flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Night, item.Target_Night).toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions class="blue-grey lighten-2 text-center card-tail">
            <span class="gate-text equip-text">{{ currentLabels.equipStatus  }}</span><span class="ml-8 gate-text equip-text">{{ gateTotal.gate2.statusNormal }} / {{ gateTotal.gate2.statusTotal }}</span>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex lg4 md12 pa-2>
        <v-toolbar color="blue-grey lighten-2" dark dense>
            <v-icon class="black--text">mdi-check-network</v-icon>
            <v-toolbar-title class="ml-1 black--text">GATE 3</v-toolbar-title>
            <v-spacer></v-spacer>
            <div class="d-lg-none d-block d-xl-block">
              <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate3.target.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate3.count.toLocaleString() }} </span>
              <span> | </span>
              <span class="gate-text red--text  title-text">{{ currentLabels.production }} {{ gateTotal.gate3.rate.toFixed(1)}} %</span>
            </div>
        </v-toolbar> 
        <v-card class="white--text subheading">
          <v-container class="equip-card">
            <v-row dense align="center" justify="center" class="d-lg-block d-xl-none d-none">
              <v-col cols="12">
                <v-card color="" flat tile height="42" class="text-center grey lighten-2" >
                  <span class="gate-text white--text title-text">{{ currentLabels.target }} {{ gateTotal.gate3.target.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text indigo--text title-text">{{ currentLabels.count }} {{ gateTotal.gate3.count.toLocaleString() }} </span>
                  <span> | </span>
                  <span class="gate-text red--text  title-text">{{ currentLabels.production }} {{ gateTotal.gate3.rate.toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense align="center" justify="center" v-for="(item, i) in rtData.gate3" :key="i" >
              <v-col cols="2" lg="2" class="max-100">
                <v-card color="green" flat tile height="42" class="text-center" >
                  <span class="gate-text equip-text">{{ item.Line }}</span>
                </v-card>
              </v-col>
              <v-col cols="8" lg="8" class="flex-space-production">
                <v-card flat tile class="equip-text">
                  <v-progress-linear v-if="timeset() == 'DAY'" :color="getStatusLevel(item.Non_Operation_Type)" :value="ProductionRate(item.Count_Day, item.Target_Day)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Day).toLocaleString() }} / {{ Number(item.Count_Day).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                  <v-progress-linear v-else :color="getStatusLevel(item.Non_Operation_Type)" :value="ProductionRate(item.Count_Night, item.Target_Night)" height="42">
                    <v-layout wrap class="px-3">
                      <v-flex class="text-left">
                        {{ item.Equip }}
                      </v-flex>
                      <v-flex class="text-right">
                        ({{ Number(item.Target_Night).toLocaleString() }} / {{ Number(item.Count_Night).toLocaleString() }})
                      </v-flex>
                    </v-layout>
                  </v-progress-linear>
                </v-card>
              </v-col>
              <v-col cols="2" lg="2" class="max-100">
                <v-card v-if="timeset() == 'DAY'" flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Day, item.Target_Day).toFixed(1)}} %</span>
                </v-card>
                <v-card v-else flat tile color="#ddd" height="42" class="text-center">
                  <span class="gate-text equip-text">{{ ProductionRate(item.Count_Night, item.Target_Night).toFixed(1)}} %</span>
                </v-card>
              </v-col>
            </v-row>
            <v-row dense align="center" justify="center" class="d-lg-block hidden">
              <v-col cols="12" height="42"><v-card flat dense height="42"></v-card></v-col>
            </v-row>
            <v-row dense align="center" justify="center" class="d-lg-block hidden">
              <v-col cols="12" height="42"><v-card flat dense height="42"></v-card></v-col>
            </v-row>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions class="blue-grey lighten-2 text-center card-tail">
            <span class="gate-text equip-text">{{ currentLabels.equipStatus  }}</span><span class="ml-8 gate-text equip-text">{{ gateTotal.gate3.statusNormal }} / {{ gateTotal.gate3.statusTotal }}</span>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <Employee></Employee>
    <Legend></Legend>
  </v-card>
</template>
<script>
import Employee from '@/components/Employee.vue'
import Legend from '@/components/Legend.vue'
import { mapState } from 'vuex'
  export default {
    name: 'Production',
    components: {
      Employee,
      Legend
    },
    data () {
      return {
        rtData : {
          gate1 : [],
          gate2 : [],
          gate3 : []
        },
        gateTotalDefault : {
          gate1 :{
            target : 0,
            count : 0,
            rate : 0,
            statusNormal: 0,
            statusTotal: 0
          },
          gate2 :{
            target : 0,
            count : 0,
            rate : 0,
            statusNormal: 0,
            statusTotal:0
          },
          gate3 :{
            target : 0,
            count : 0,
            rate : 0,
            statusNormal: 0,
            statusTotal:0
          }
        },
        gateTotal : {},
        total : {
          target: '',
          count: '',
          rate: ''
        }
      }
    },
    created () {
      //this.randomData()
      //this.eqpName = this.$store.getters.getEqpName(this.$route.params.gate, this.$route.params.id)
     // this.getStatus()
   //   this.statusInterval()
    //  this.getData()
      this.cal()
    },
    mounted () {
    },
    watch: {
      '$route'(to, from) {
       // this.gateNo = to.params.gate
       // this.eqpNo = to.params.id
       // this.eqpName = this.$store.getters.getEqpName(to.params.gate, to.params.id)
       // clearInterval(this.statusDataInterval) 
       // this.getStatus()
       // this.statusInterval()
      }
    },
    computed:{ 
      ...mapState([
        'userInfo',
        'currentLabels',
        'mainHistory'
      ])
    },
    beforeDestroy () {
       clearInterval(this.opcDataInterval)
       clearInterval(this.statusDataInterval)
    },
    methods: {
      getStatus () {
        this.axios.get(`/api/getstatus?gate=${this.gateNo}&unit=${this.eqpNo}`)
        .then((result) => {
          //console.log(result.data)
          this.currentData.targetQty = result.data[0].targetQty
          this.currentData.comment = result.data[0].comment
          switch (result.data[0].equipStatus) {
            case '정상가동':
              this.currentData.equipStatus = 1
              break;
            case '품질이상':
              this.currentData.equipStatus = 2
              break;
            case '설비이상':
              this.currentData.equipStatus = 3
              break;
            case '자재결품':
              this.currentData.equipStatus = 4
              break;
            case '계획정지':
              this.currentData.equipStatus = 5
              break;
            case '안전이상':
              this.currentData.equipStatus = 6
              break;
            default:
              this.currentData.equipStatus = 7
              break;
          }
        })
        .catch(e => {
          console.log(e)
        })
      },
      statusInterval () {
        this.statusDataInterval = setInterval(() => {
          this.getStatus()
        }, 10000)
      },
      getStatusLevel (value) {
        switch (value) {
          case '정상가동':
            return 'green';
            break;
          case '품질이상':
            return '#FEB6B7';
            break;
          case '설비이상':
            return 'red';
            break;
          case '자재결품':
            return 'yellow';
            break;
          case '계획정지':
            return '#FEC000';
            break;
          case '안전이상':
            return '#D9D9D9';
            break;
          default:
            break;
        }
      },
      cal () {
        this.gateTotal = Object.assign({}, this.gateTotalDefault)
        let timeset = this.timeset()
        let totalTarget = 0
        let totalCount = 0
        this.mainHistory.map( e => {
          switch (e.Gate) {
            case '0':
              this.rtData.gate1.push(e)
              if (timeset === 'DAY') {
                this.gateTotal.gate1.target = Number(this.gateTotal.gate1.target) + Number(e.Target_Day)
                this.gateTotal.gate1.count = Number(this.gateTotal.gate1.count) + Number(e.Count_Day)
              } else {
                this.gateTotal.gate1.target = Number(this.gateTotal.gate1.target) + Number(e.Target_Night)
                this.gateTotal.gate1.count = Number(this.gateTotal.gate1.count) + Number(e.Count_Night)
              }
              if (e.Non_Operation_Type === '정상가동') this.gateTotal.gate1.statusNormal = Number(this.gateTotal.gate1.statusNormal) + 1
              totalTarget = Number(totalTarget) + Number(e.Target)
              totalCount = Number(totalCount) + Number(e.Count_Day) + Number(e.Count_Night)
              break;
            case '1':
              this.rtData.gate2.push(e)
              if (timeset === 'DAY') {
                this.gateTotal.gate2.target = Number(this.gateTotal.gate2.target) + Number(e.Target_Day)
                this.gateTotal.gate2.count = Number(this.gateTotal.gate2.count) + Number(e.Count_Day)
              } else {
                this.gateTotal.gate2.target = Number(this.gateTotal.gate2.target) + Number(e.Target_Night)
                this.gateTotal.gate2.count = Number(this.gateTotal.gate2.count) + Number(e.Count_Night)
              }
              if (e.Non_Operation_Type === '정상가동') this.gateTotal.gate2.statusNormal = Number(this.gateTotal.gate2.statusNormal) + 1
              totalTarget = Number(totalTarget) + Number(e.Target)
              totalCount = Number(totalCount) + Number(e.Count_Day) + Number(e.Count_Night)
              break;
            case '2':
              this.rtData.gate3.push(e)
              if (timeset === 'DAY') {
                this.gateTotal.gate3.target = Number(this.gateTotal.gate3.target) + Number(e.Target_Day)
                this.gateTotal.gate3.count = Number(this.gateTotal.gate3.count) + Number(e.Count_Day)
              } else {
                this.gateTotal.gate3.target = Number(this.gateTotal.gate3.target) + Number(e.Target_Night)
                this.gateTotal.gate3.count = Number(this.gateTotal.gate3.count) + Number(e.Count_Night)
              }
              if (e.Non_Operation_Type === '정상가동') this.gateTotal.gate3.statusNormal = Number(this.gateTotal.gate3.statusNormal) + 1
              totalTarget = Number(totalTarget) + Number(e.Target)
              totalCount = Number(totalCount) + Number(e.Count_Day) + Number(e.Count_Night)
              break;
            default:
              break;
          }
        })
        this.gateTotal.gate1.rate = this.ProductionRate(this.gateTotal.gate1.count, this.gateTotal.gate1.target)
        this.gateTotal.gate2.rate = this.ProductionRate(this.gateTotal.gate2.count, this.gateTotal.gate2.target)
        this.gateTotal.gate3.rate = this.ProductionRate(this.gateTotal.gate3.count, this.gateTotal.gate3.target)
        this.total.target = totalTarget
        this.total.count = totalCount
        this.total.rate = this.ProductionRate(this.total.count, this.total.target)
        this.gateTotal.gate1.statusTotal = this.rtData.gate1.length
        this.gateTotal.gate2.statusTotal = this.rtData.gate2.length
        this.gateTotal.gate3.statusTotal = this.rtData.gate3.length
      },
      timeset () {
        const D = new Date()
        let hour = D.getHours()
        if (hour > 7 && hour < 21 ) {
          return 'DAY'
        } else {
          return 'NIGHT'
        }
      },
      ProductionRate (count, target) {
        if (target > 0) {
          return (count/target)*100
        } else {
          return 0
        }
      },
      getData () {
        this.opcDataInterval = setInterval(() => {
          this.axios.get(`/api/getdata`)
          .then((result) => {
            //console.log(result.data)
            let prefix = this.gateNo.toString() + '.' + this.eqpNo.toString() + '.'
            this.currentData.currentQty = parseInt(result.data[prefix + 'OK']) + parseInt(result.data[prefix + 'NG'])
            this.currentData.productionAR = this.roundFix(this.currentData.currentQty / this.currentData.targetQty * 100)
          })
        }, 1000)
      },
      randomRange(n1, n2) {
        return Math.floor( (Math.random() * (n2 - n1 + 1)) + n1 )
      },
      randomData () {
        this.opcDataInterval = setInterval(() => {
          this.targetValue = this.randomRange(19,26)
          this.currentValue = this.randomRange(23,25)
          this.achievementRate = this.randomRange(10,98)
          this.currentData.equipStatus = this.randomRange(1,6)
        }, 1000)
      },
      roundFix(n) {
        return n || n === 0 ?  n.toFixed(2) : 'NaN'
      }
    }
  }
</script>
<style>

</style>
